module.exports = __webpack_public_path__ + "assets/0d639e00778f1ef6813d6f09736413ad.jpg";